var _style, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeaver4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 993.7 662.2",
    style: {
      enableBackground: "new 0 0 993.7 662.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#FABA29;}\r\n\t.st3{fill:none;}\r\n\t.st4{fill:#412514;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st5{fill:#FFFFFF;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st6{fill:#010101;}\r\n\t.st7{fill:none;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st8{fill:#4A4A4B;}\r\n\t.st9{fill:#FFFFFF;stroke:#010101;stroke-width:5;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st10{fill:#4A4A4B;stroke:#010101;stroke-width:6;stroke-miterlimit:10;}\r\n\t.st11{fill:#EB2627;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st12{fill:#010101;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st13{fill:#737374;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st14{fill:#D42B27;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st15{fill:#F04B43;}\r\n\t.st16{fill:#969696;stroke:#010101;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st17{fill:none;stroke:#010101;stroke-width:5;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st18{fill:#D42B27;}\r\n\t.st19{fill:#B72025;}\r\n\t.st20{fill:none;stroke:#F04B43;stroke-width:7;stroke-miterlimit:10;}\r\n\t.st21{fill:none;stroke:#D42B27;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st22{fill:none;stroke:#737374;stroke-width:5;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 993.7,
    height: 662.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M560,324.9c3.7,2.7,7.7,4.6,12,6.1c2.3,0.4,4.7,0.6,7.1,0.6c22.6,0,41-18.4,41-41c0-22.7-18.4-41-41-41 c-22.7,0-41,18.4-41,41c0,10,3.6,19.1,9.5,26.2C551.5,319.1,555.7,321.7,560,324.9z M563.4,277.4c-0.1,0.6-0.2,1.3-0.2,2 c0,5,4.1,9.1,9.1,9.1c5,0,9.1-4.1,9.1-9.1c0-4.2-2.9-7.8-6.8-8.8c1.5-0.3,3-0.5,4.6-0.5c11.3,0,20.5,9.2,20.5,20.5 c0,11.3-9.2,20.5-20.5,20.5c-11.3,0-20.5-9.2-20.5-20.5C558.5,285.6,560.4,281,563.4,277.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M414.7,331.6c2.4,0,4.8-0.2,7.1-0.6c4.3-1.5,8.3-3.5,12-6.1c4.3-3.1,8.4-5.8,12.4-8 c5.9-7.1,9.5-16.2,9.5-26.2c0-22.7-18.4-41-41-41c-22.6,0-41,18.4-41,41C373.7,313.3,392.1,331.6,414.7,331.6z M399.1,277.4 c-0.1,0.6-0.2,1.3-0.2,2c0,5,4.1,9.1,9.1,9.1c5,0,9.1-4.1,9.1-9.1c0-4.2-2.9-7.8-6.8-8.8c1.5-0.3,3-0.5,4.6-0.5 c11.3,0,20.5,9.2,20.5,20.5c0,11.3-9.2,20.5-20.5,20.5c-11.3,0-20.5-9.2-20.5-20.5C394.2,285.6,396.1,281,399.1,277.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M341.5,199.6c-10,0-18.2,8.1-18.2,18.2c0,10,8.1,18.2,18.2,18.2c10,0,18.2-8.1,18.2-18.2 C359.7,207.7,351.5,199.6,341.5,199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M652.3,199.6c-10,0-18.2,8.1-18.2,18.2c0,10,8.1,18.2,18.2,18.2c10,0,18.2-8.1,18.2-18.2 C670.4,207.7,662.3,199.6,652.3,199.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M341.5,199.6c-10,0-18.2,8.1-18.2,18.2c0,10,8.1,18.2,18.2,18.2c10,0,18.2-8.1,18.2-18.2 C359.7,207.7,351.5,199.6,341.5,199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M556.6,436.7c1.1,0.1,2.3,0.1,3.5,0.1l0,0c38.5-0.1,69.6-27.6,69.6-61.6c0-33.5-46.5-14.8-77.6-36 c-0.5-0.3-1-0.6-1.5-0.9c-2.8-2-5.4-3.8-7.9-5.3c-0.5-0.4-1-0.7-1.6-1.1c-2.6-1.7-5.6-3.3-9.4-4.6c-7.4-2.7-16.8-4.5-26.9-5.1 c-2.6-0.2-5.2-0.3-7.9-0.3c-2.7,0-5.3,0.1-7.9,0.3c-10.1,0.6-19.5,2.3-26.9,5.1c-3.8,1.4-6.8,3-9.4,4.6 c-0.5,0.4-1.1,0.7-1.6,1.1c-2.5,1.5-5.2,3.3-7.9,5.3c-0.5,0.4-1,0.6-1.5,0.9c-31.1,21.2-77.6,2.5-77.6,35.9 c0,33.9,31.1,61.5,69.6,61.6c0,0,0,0,0,0c1.2,0,2.3,0,3.5-0.1c19.2-0.8,49.4-20.4,51.6-21.9c2.5-1.7,5.6-3.4,8.1-3.4 c2.5,0,5.6,1.8,8.1,3.4C507.2,416.2,537.4,435.9,556.6,436.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M652.3,235.9c10,0,18.2-8.1,18.2-18.2c0-10-8.1-18.2-18.2-18.2c-10,0-18.2,8.1-18.2,18.2 C634.1,227.8,642.3,235.9,652.3,235.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M663,255.1c6.1-1.7,11.8-5,16.6-9.8c15-15,15-39.6,0-54.7c-7.5-7.5-17.4-11.3-27.3-11.3 c-9.9,0-19.8,3.8-27.3,11.3c-6.1,6.1-9.7,13.8-10.9,21.8c-17.2-11.4-35.7-20.4-55-26.5c0.9-1.2,2-2.4,3-3.5 c-12.9-0.4-23.9-6.7-31-16.1c-11.2-7.4-18.5-20.3-19.1-34.7c-0.1-3.2,0.3-6.6,1.2-9.9c-46.7,14.2-82.1,38.8-108,63.6 c-4.5,4.3-8.6,8.6-12.5,12.8c-3.9,4.3-7.6,8.5-11,12.6c-1.1,1.1-1.7,1.7-1.7,1.7c-1.1-8-4.8-15.7-10.9-21.8 c-7.5-7.5-17.4-11.3-27.3-11.3c-9.9,0-19.8,3.8-27.3,11.3c-15,15-15,39.6,0,54.7c4.8,4.8,10.5,8,16.6,9.8 c-35,39.1-60.7,90.4-72.6,148.4c61.1,26.9,239,105.3,239,105.3l238.4-105.1C723.7,345.7,698,294.3,663,255.1z M341.5,235.9 c-10,0-18.2-8.1-18.2-18.2c0-10,8.1-18.2,18.2-18.2c10,0,18.2,8.1,18.2,18.2C359.7,227.8,351.5,235.9,341.5,235.9z  M560.1,436.8L560.1,436.8c-1.2,0-2.3,0-3.5-0.1c-19.2-0.8-49.4-20.4-51.6-21.9c-2.5-1.7-5.6-3.4-8.1-3.4 c-2.5,0-5.6,1.8-8.1,3.4c-2.2,1.5-32.4,21.1-51.6,21.9c-1.1,0.1-2.3,0.1-3.5,0.1c0,0,0,0,0,0c-38.4-0.1-69.6-27.6-69.6-61.6 c0-33.5,46.5-14.8,77.6-35.9c0.5-0.3,1-0.6,1.5-0.9c2.8-2,5.4-3.8,7.9-5.3c0.5-0.4,1-0.7,1.6-1.1c2.6-1.7,5.6-3.3,9.4-4.6 c7.5-2.7,16.8-4.5,26.9-5.1c2.6-0.2,5.2-0.3,7.9-0.3c2.7,0,5.3,0.1,7.9,0.3c10.1,0.6,19.5,2.3,26.9,5.1c3.8,1.4,6.8,3,9.4,4.6 c0.5,0.4,1.1,0.7,1.6,1.1c2.5,1.5,5.2,3.3,7.9,5.3c0.5,0.4,1,0.6,1.5,0.9c31.1,21.2,77.6,2.5,77.6,36 C629.7,409.1,598.5,436.6,560.1,436.8z M634.1,217.8c0-10,8.1-18.2,18.2-18.2c10,0,18.2,8.1,18.2,18.2c0,10-8.1,18.2-18.2,18.2 C642.3,235.9,634.1,227.8,634.1,217.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M579,249.6c22.6,0,41,18.4,41,41c0,22.7-18.4,41-41,41c-2.4,0-4.8-0.2-7.1-0.6c-4.3-1.5-8.3-3.5-12-6.1 c-4.3-3.1-8.4-5.8-12.4-8c-5.9-7.1-9.5-16.2-9.5-26.2C538,268,556.4,249.6,579,249.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M579,311.1c11.3,0,20.5-9.2,20.5-20.5c0-11.3-9.2-20.5-20.5-20.5c-1.6,0-3.1,0.2-4.6,0.5 c3.9,1,6.8,4.5,6.8,8.8c0,5-4.1,9.1-9.1,9.1c-5,0-9.1-4.1-9.1-9.1c0-0.7,0.1-1.4,0.2-2c-3,3.6-4.8,8.2-4.8,13.2 C558.5,301.9,567.7,311.1,579,311.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M496.9,396.6c16.2,0,30.4-8.5,38.4-21.4c4.3-6.9,6.8-15,6.8-23.7c0-11.6-19.5-17.8-40.4-18.6 c-1.6-0.1-3.2-0.1-4.7-0.1c-1.6,0-3.2,0-4.7,0.1c-20.9,0.8-40.4,7-40.4,18.6c0,8.7,2.5,16.8,6.7,23.7 C466.5,388,480.7,396.6,496.9,396.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M435.2,437c15-0.5,29.5-4.5,42.1-11.6c4.1-2.3,7.9-4.9,11.5-7.8V455c0,8.7-6.2,15.8-13.9,15.8h-20.8 c-5.6,0-10.7-3.8-12.8-9.7C438.6,453.5,436.6,445.5,435.2,437z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M505,455v-37.5c3.6,2.9,7.4,5.5,11.5,7.8c12.7,7.2,27.1,11.2,42.1,11.6c-1.4,8.4-3.4,16.5-6.2,24.1 c-2.1,5.9-7.2,9.7-12.8,9.7h-20.8C511.2,470.8,505,463.7,505,455z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M559.8,439.3c-1,0-1.9,0-2.9-0.1l-0.4,0c-20.8-0.8-52.6-22.1-52.9-22.4c-4-2.7-6-3-6.7-3 c-1.5,0-3.9,1.1-6.7,3c-0.3,0.2-32.1,21.5-52.9,22.4l-0.4,0c-1,0-1.9,0.1-2.9,0.1l-0.2,0c-39.8-0.1-72.1-28.9-72.1-64.1 c0-21.7,18-23.8,37.1-26c13.6-1.6,29-3.4,41.6-12c0.3-0.2,0.5-0.3,0.8-0.5c0.2-0.1,0.4-0.2,0.6-0.4c2.6-1.9,5.3-3.7,8-5.4 c0.5-0.3,0.9-0.6,1.4-1l0.2-0.1c2.9-1.9,6.2-3.5,9.9-4.9c7.6-2.8,17.2-4.6,27.6-5.2c2.9-0.2,5.5-0.3,8-0.3c2.5,0,5.1,0.1,8,0.3 c10.5,0.6,20,2.4,27.6,5.2c3.7,1.4,7,3,9.9,4.9l0.2,0.1c0.5,0.3,1,0.6,1.4,1c2.7,1.6,5.4,3.4,8,5.4c0.2,0.1,0.4,0.3,0.6,0.4 c0.3,0.2,0.5,0.3,0.8,0.5c12.5,8.5,28,10.4,41.6,12c19.1,2.3,37.1,4.4,37.1,26c0,35.2-32.3,64-72.1,64.1L559.8,439.3z  M496.9,335.3c-1.5,0-3,0-4.6,0.1c-22.4,0.9-38,7.5-38,16.1c0,7.9,2.2,15.7,6.4,22.4c7.8,12.7,21.4,20.2,36.2,20.2 c14.9,0,28.4-7.5,36.2-20.2c4.2-6.7,6.4-14.5,6.4-22.4c0-8.6-15.6-15.2-38-16.1C499.9,335.3,498.4,335.3,496.9,335.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M496.9,321.9c2.7,0,5.3,0.1,7.9,0.3c10.1,0.6,19.5,2.3,26.9,5.1c3.8,1.4,6.8,3,9.4,4.6 c0.5,0.4,1.1,0.7,1.6,1.1c2.5,1.5,5.2,3.3,7.9,5.3c0.5,0.4,1,0.6,1.5,0.9c31.1,21.2,77.6,2.5,77.6,36 c0,33.9-31.1,61.5-69.6,61.6c-0.1,0-0.2,0-0.2,0c-1.1,0-2.2-0.1-3.2-0.1c-19.2-0.8-49.4-20.4-51.6-21.9 c-2.5-1.7-5.6-3.4-8.1-3.4c-2.5,0-5.6,1.8-8.1,3.4c-2.2,1.5-32.4,21.1-51.6,21.9c-1.1,0-2.1,0.1-3.2,0.1c-0.1,0-0.2,0-0.2,0 c-38.4-0.1-69.6-27.6-69.6-61.6c0-33.5,46.5-14.8,77.6-35.9c0.5-0.3,1-0.6,1.5-0.9c2.8-2,5.4-3.8,7.9-5.3 c0.5-0.4,1-0.7,1.6-1.1c2.6-1.7,5.6-3.3,9.4-4.6c7.5-2.7,16.8-4.5,26.9-5.1C491.6,322,494.2,321.9,496.9,321.9 M496.9,396.6 c16.2,0,30.4-8.5,38.4-21.4c4.3-6.9,6.8-15,6.8-23.7c0-11.6-19.5-17.8-40.4-18.6c-1.6-0.1-3.2-0.1-4.7-0.1 c-1.6,0-3.2,0-4.7,0.1c-20.9,0.8-40.4,7-40.4,18.6c0,8.7,2.5,16.8,6.7,23.7C466.5,388,480.7,396.6,496.9,396.6 M496.9,316.9 c-2.5,0-5.2,0.1-8.2,0.3c-10.7,0.6-20.5,2.5-28.3,5.4c-3.8,1.4-7.3,3.1-10.4,5.1l-0.2,0.1c-0.5,0.3-1,0.6-1.5,1 c-2.7,1.7-5.5,3.5-8.1,5.5c-0.1,0-0.3,0.2-0.4,0.3c-0.3,0.2-0.6,0.4-0.9,0.6c-12,8.2-27.1,10-40.5,11.6 c-9.9,1.2-19.2,2.3-26.3,5.8c-8.7,4.4-13,11.8-13,22.7c0,17.9,7.8,34.6,22.1,47.2c14,12.4,32.7,19.3,52.5,19.4 c0.1,0,0.2,0,0.3,0c1,0,2,0,3-0.1l0.5,0c21.5-0.9,53.9-22.6,54.2-22.8c3-2,4.8-2.6,5.3-2.6c0.5,0,2.3,0.5,5.3,2.6 c0.3,0.2,32.8,21.9,54.2,22.8l0.5,0c1,0,1.9,0.1,3,0.1c0.1,0,0.2,0,0.3,0l0,0c19.8-0.1,38.5-6.9,52.5-19.4 c14.2-12.6,22.1-29.4,22.1-47.2c0-10.9-4.2-18.3-13-22.7c-7.1-3.6-16.4-4.7-26.3-5.8c-13.3-1.6-28.4-3.4-40.5-11.6 c-0.3-0.2-0.6-0.4-0.9-0.6c-0.2-0.1-0.3-0.2-0.4-0.3c-2.7-2-5.4-3.8-8.1-5.5c-0.5-0.4-1-0.7-1.5-1l-0.2-0.1 c-3.1-2-6.6-3.7-10.4-5.1c-7.8-2.9-17.6-4.8-28.3-5.4C502.1,317,499.4,316.9,496.9,316.9L496.9,316.9z M496.9,391.6 c-14,0-26.7-7.1-34.1-19c-3.9-6.3-6-13.6-6-21.1c0-7,15.3-12.8,35.6-13.6c1.6-0.1,3.1-0.1,4.5-0.1c1.4,0,2.9,0,4.5,0.1 c20.3,0.8,35.6,6.6,35.6,13.6c0,7.5-2.1,14.8-6,21.1C523.6,384.5,510.9,391.6,496.9,391.6L496.9,391.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M414.7,249.6c22.7,0,41,18.4,41,41c0,10-3.6,19.1-9.5,26.2c-4,2.2-8.2,4.9-12.4,8c-3.6,2.7-7.7,4.6-12,6.1 c-2.3,0.4-4.7,0.6-7.1,0.6c-22.6,0-41-18.4-41-41C373.7,268,392.1,249.6,414.7,249.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M414.7,311.1c11.3,0,20.5-9.2,20.5-20.5c0-11.3-9.2-20.5-20.5-20.5c-1.6,0-3.1,0.2-4.6,0.5 c3.9,1,6.8,4.5,6.8,8.8c0,5-4.1,9.1-9.1,9.1c-5,0-9.1-4.1-9.1-9.1c0-0.7,0.1-1.4,0.2-2c-3,3.6-4.8,8.2-4.8,13.2 C394.2,301.9,403.4,311.1,414.7,311.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M710.6,622.3c-4.4,8.6-53.8,40.5-80.5,11.9c-36.9-39.3,13.1-94.7,18-142.2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "572.9,473 616.6,529 563.3,553.6 579.7,600.1 496.4,634.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "419.9,473 376.2,529 429.4,553.6 413,600.1 496.4,634.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M421.1,475h-1.2l76.5,161.2L572.9,475h-1.2c-18.5,11.6-45.4,19-75.3,19S439.6,486.7,421.1,475z"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 271.6,
    y: 578.4,
    transform: "matrix(0.9153 -0.4028 0.4028 0.9153 -210.1985 179.9894)",
    className: "st10",
    width: 102.5,
    height: 22.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 618.7,
    y: 578.4,
    transform: "matrix(-0.9153 -0.4028 0.4028 -0.9153 1045.5867 1399.3511)",
    className: "st10",
    width: 102.5,
    height: 22.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "459.2,557.8 483.8,514.9 509.6,514.9 534.6,555.6 496.4,634.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M250.8,477.1c0,42.2,7.1,82.3,19.9,118.7c1.1,2.8,2.5,6,4.2,9.6c2.1,4.1,21.5,46.2,22.3,47.6 c20.8,35.3,47.8,64.8,78.9,86.3c6.8,4.7,14.5,6.9,22.2,6.9c12.3,0,24.4-5.7,32.1-16.4c14.9-20.6,39.1-34,66.5-34 c27.3,0,51.6,13.4,66.5,34c7.7,10.6,19.7,16.3,32,16.3c7.9,0,15.8-2.3,22.7-7.1c31.5-21.8,58.6-51.9,79.5-87.7l0,0l0-0.1 c0.4-0.8,24.3-52.4,25.4-55.2c12.8-36.4,19.9-76.6,19.9-118.8c0-25.3-2.6-49.8-7.4-73.3L497.2,508.9c0,0-177.9-78.4-239-105.3 c-0.7,3.5-1.4,7.1-2,10.6C252.7,434.5,250.8,455.5,250.8,477.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M250.3,477.1c0,42.2,7.1,82.3,19.9,118.7c1.1,2.8,2.5,6,4.2,9.6c2.1,4.1,21.5,46.2,22.3,47.6 c20.8,35.3,47.8,64.8,78.9,86.3c6.8,4.7,14.5,6.9,22.2,6.9c12.3,0,24.4-5.7,32.1-16.4c14.9-20.6,39.1-34,66.5-34 c27.3,0,51.6,13.4,66.5,34c7.7,10.6,19.7,16.3,32,16.3c7.9,0,15.8-2.3,22.7-7.1c31.5-21.8,58.6-51.9,79.5-87.7l0,0l0-0.1 c0.4-0.8,24.3-52.4,25.4-55.2c12.8-36.4,19.9-76.6,19.9-118.8c0-25.3-2.6-49.8-7.4-73.3l-170.5,75.1c-43.3,19.1-92.6,19.1-135.8,0 c-57-25.1-134.7-59.4-171.1-75.4c-0.7,3.5-1.4,7.1-2,10.6C252.2,434.5,250.3,455.5,250.3,477.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M374.2,581.6c4.4,19,3.4,37.1-11.2,52.6c-26.8,28.5-76.1-3.4-80.5-11.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M710.2,622.3c-4.4,8.6-53.8,40.5-80.5,11.9c-14.6-15.5-15.6-33.5-11.2-52.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M629.7,175.5c-5-29.7-14.5-39.1-30.1-64c-20.5-32.7-30.9-48.9-95.2-48.9c-60.2,0-87.6,31.8-98.7,48 c-22.5,32.9-26.7,56-26.7,56s20.1,30.8,62.8,39.1s115.6,13,122.1,9.5s28.4-20.7,32.6-23.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M645.3,210c-85.5,56.1-195.2,57.3-280.7,3.6c-12.5-8.3,0-14.6,0-28.4c0-2,0-4,0-5.9 c0-13.7,10.1-18.1,23.3-11.5c73.5,37.2,160.6,37.2,234.1,0c13.2-6.6,23.3-2.2,23.3,11.5c0,2,0,4,0,5.9 C645.3,198.9,657.8,201.8,645.3,210z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M645.3,210c-85.5,56.1-195.2,57.3-280.7,3.6c-12.5-8.3,0-14.6,0-28.4c0-2,0-4,0-5.9 c0-13.7,10.1-18.1,23.3-11.5c73.5,37.2,160.6,37.2,234.1,0c13.2-6.6,23.3-2.2,23.3,11.5c0,2,0,4,0,5.9 C645.3,198.9,657.8,201.8,645.3,210z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M371.9,584.6l-75.3,43.5c-9.1,5.3-20.8,2.1-26-7l-9.5-16.4c-5.3-9.1-2.1-20.8,7-26l75.3-43.5 c9.1-5.3,20.8-2.1,26,7l9.5,16.4C384.1,567.7,381,579.3,371.9,584.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M621.6,584.6l75.3,43.5c9.1,5.3,20.8,2.1,26-7l9.5-16.4c5.3-9.1,2.1-20.8-7-26l-75.3-43.5 c-9.1-5.3-20.8-2.1-26,7l-9.5,16.4C609.3,567.7,612.5,579.3,621.6,584.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M348.7,475c0,0-12.3,42.7,1,57.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M646.4,475c0,0,12.3,42.7-1,57.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M406.4,509.1c-0.8,24.8-13.6,102.6-4.3,116.3c9.3,13.7,84,15,89.7,3.8s-3.6-108.9-7.8-116 C479.8,506.1,406.4,509.1,406.4,509.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M419.4,518c0,0-3.5,53.9-3.9,74.8c-0.3,20.8,0.1,37.8,1.9,40.2l9.2,2.1l2.9-119.1L419.4,518z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M485.4,518c0,0,3.5,53.9,3.9,74.8c0.3,20.8-0.1,37.8-1.9,40.2l-9.2,2.1l-2.9-119.1L485.4,518z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "448,522 444.4,636.7 455.8,636.7 460.4,521.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M406.4,509.1c-0.8,24.8-13.6,102.6-4.3,116.3c9.3,13.7,84,15,89.7,3.8s-3.6-108.9-7.8-116 C479.8,506.1,406.4,509.1,406.4,509.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M566.9,455.5c0,0,9,106.9,7.9,121s-85.7,20.2-88.5,10.3c-2.8-10-0.7-129.2,0-131.3 C487.1,453.4,566.9,455.5,566.9,455.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "509.3,464.8 509.3,591.7 522.7,591.7 520.3,462.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "538.6,464.8 542.8,589.3 556.2,586.8 549.3,462.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M491.6,589.9v-121c0,0,59.7-1.2,76.2-3.1l0.9,10.7c0,0-54.9,6.1-67.2,5.2l-1,109.6L491.6,589.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M566.9,455.5c0,0,9,106.9,7.9,121s-85.7,20.2-88.5,10.3c-2.8-10-0.7-129.2,0-131.3 C487.1,453.4,566.9,455.5,566.9,455.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M263.1,384.6c-10.4-3.1-29.4,39.1-29.9,55c-0.5,15.8,59,82.1,248.4,84.4s281.7-67.6,284.6-91 c2.9-23.4-15.8-63.3-32.3-61.6c-16.5,1.7-32.2,79.9-232.2,81.1C301.7,453.6,263.1,384.6,263.1,384.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M745.1,376c-24.6,37.1-89.6,92.2-244.9,92.8c-181.2,0.7-239.3-63.3-248.8-75.6c-1.3,1.9-3,4.3-4.6,7.2 c9.3,13.8,62.5,77.5,251.8,78.3c193.1,0.8,244.6-81.5,252.3-96.5C748.8,379.5,746.8,377.5,745.1,376z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M759.1,395.7L759.1,395.7c-25.2,37.1-93.2,93.6-258.7,94.2c-184.4,0.7-247.7-59.2-260.7-74.3 c-1.4,3.6-2.5,6.5-3.4,9.3c15.4,18.7,76.6,74.1,262.3,74.8c193.7,0.8,251.9-74,264-94C761.6,402.1,760.4,398.7,759.1,395.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M765.8,421.8c-27.7,38-98.9,92.8-265.2,93.4c-180.6,0.7-248.9-54.4-267-73.3c0,0.3,0,0.6,0,0.9 c0,11.8,7.2,18.8,7.9,19.5c29.4,24.3,100.3,62.4,257.3,63c172.4,0.7,241.1-56.1,264.8-84.9C763.7,440.1,766.9,434.6,765.8,421.8 z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M762.7,405.8C762.7,405.8,762.7,405.8,762.7,405.8c-1-3.7-2.3-7.1-3.6-10l-0.1,0c-0.1,0.1-0.1,0.1-0.2,0.2 c-2.3-5.1-5-9.8-7.9-13.7c0,0,0,0,0-0.1c-0.4-0.5-0.8-1-1.2-1.4c-5-6.2-10.6-10-15.9-9.5c-16.5,1.7-32.2,79.9-232.2,81.1 s-238.6-67.8-238.6-67.8c-4.4-1.3-10.4,5.5-15.8,15.1c-0.2,0.3-0.3,0.5-0.5,0.8c0,0,0,0,0,0c-7.2,12.9-13.4,30.2-13.6,39.1 c0,0.8,0.1,1.7,0.4,2.8c0,0.1,0,0.3,0,0.4c0,11.8,7.2,18.8,7.9,19.5c29.4,24.3,100.3,62.4,257.3,63c139.6,0.6,211.2-36.6,246-66 c7.7-6,13.3-11.7,16.9-16.6c0.7-0.8,1.3-1.6,1.9-2.3c0-0.1,0.5-0.9,1.1-2.6c0.8-1.7,1.4-3.3,1.5-4.8 C767.2,425,765.7,415.2,762.7,405.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M546.1,77.8c0,0,46.7,32.4,49.8,81.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M522.7,73.8c0,0,42.1,66.2,38.5,100"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M473.2,75.4c0,0-35.1,17.8-68.1,78.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M491.6,75.4c0,0-39.2,53.3-39.8,101.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 509.3,
    y1: 75.4,
    x2: 499.8,
    y2: 180.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M386.1,180.3c0,0-6.2,23.4-9.9,29.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M410.4,188c-5.3,11.6-8.5,30.8-11.7,36.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M448,199.6c0,0-8.9,32.2-10.4,36.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 499.8,
    y1: 208.2,
    x2: 499.8,
    y2: 243.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M542,207.7c0,0,1.9,24.2,4.4,28.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M575,195.1c0,0,6.1,21.3,17.3,30.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M616.6,180.3c0,0,0.6,22,8.3,27.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M475.4,206.4c0,0-1.3,25.1-5.8,31.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 430.1,
    y1: 194.3,
    x2: 420.7,
    y2: 228.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M522.7,209.9c0,0-2.8,28.7,2,33.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M558.5,203.5c0,0,6.2,21.6,12.4,28.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M599.6,191.5c0,0,2.5,21.4,8.3,26.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 282.5,
    y1: 589.3,
    x2: 294.2,
    y2: 608.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 304.7,
    y1: 578.9,
    x2: 315.8,
    y2: 599
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M324.7,568.9c4,3.5,7.6,20.8,7.6,20.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 346.6,
    y1: 553.6,
    x2: 355.8,
    y2: 578.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 641.6,
    y1: 547.1,
    x2: 631.4,
    y2: 572.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 663.6,
    y1: 556.3,
    x2: 651.6,
    y2: 581.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 685.2,
    y1: 568.9,
    x2: 672.3,
    y2: 594.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 706.9,
    y1: 581.7,
    x2: 690.5,
    y2: 611.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 722.5,
    y1: 595.8,
    x2: 710.2,
    y2: 619.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaver4);
export default __webpack_public_path__ + "static/media/beaver4.42434d9051f2405f4084c56ae826328b.svg";
export { ForwardRef as ReactComponent };